import React, {useMemo} from 'react'
import {UIGameTimer} from './UIGameTimer'
import {tempIsGameEndDefined} from '../UIGameEnd'
import {useGameStore} from '../../store/GameStoreContext'
import {useGameValidator} from '../../store/selectors/useGameValidator'

interface UIGameTimerContainerProps {
    timerStyle: 'white' | 'beige'
    className?: string | undefined
}

export const UIGameTimerContainer = ({
    timerStyle,
    className,
}: UIGameTimerContainerProps) => {
    const timeLeftInSeconds = useGameStore((state) => state.timeLeftInSeconds)
    const isPaused = useGameStore((state) => state.gamePause.isPaused)
    const gameValidator = useGameValidator()
    const myColor = useGameStore((state) => state.myColor)

    const isMyPlayerTakingAction = useMemo(() => {
        const playersTakingAction = gameValidator.getPlayersTakingAction()
        return playersTakingAction.includes(myColor)
    }, [gameValidator, myColor])

    if(tempIsGameEndDefined) return null

    return <UIGameTimer
        className={className}
        timeLeftInSeconds={timeLeftInSeconds}
        isMyPlayerTakingAction={isMyPlayerTakingAction}
        isPaused={isPaused}
        timerStyle={timerStyle} />
}
